module.exports = __webpack_public_path__ + "static/media/AthenianHorseman.d51f9a58.jpg";